import { faArrowTurnLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FC, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import { Loading } from '../loading';

type IndicatorSizeType = 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
interface IndicatorProps {
  size?: IndicatorSizeType;
}
const XXSmallIconStyle = css`
  width: 16px;
  height: 16px;
  font-size: 9px;
  line-height: 12px;
`;
const XSmallIconStyle = css`
  width: 20px;
  height: 20px;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-01);
`;
const SmallIconStyle = css`
  width: var(--height-sm);
  height: var(--height-sm);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-01);
`;
const MediumIconStyle = css`
  width: var(--height-base);
  height: var(--height-base);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-03);
`;
const LargeIconStyle = css`
  width: var(--height-lg);
  height: var(--height-lg);
  font-size: var(--font-size-lg);
  line-height: var(--line-height-03);
`;
const Indicator = styled.div<IndicatorProps>`
  ${({ size }) => {
    switch (size) {
      case 'xxs':
        return XXSmallIconStyle;
      case 'xs':
        return XSmallIconStyle;
      case 'sm':
        return SmallIconStyle;
      case 'md':
        return MediumIconStyle;
      case 'lg':
        return LargeIconStyle;
      default:
        return MediumIconStyle;
    }
  }};
  border: 1px solid var(--icon-primary);
  letter-spacing: 0;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ActionableButton = styled(Indicator)`
  cursor: pointer;
`;

interface Props {
  aiGenerated: boolean;
  regenerate?: () => Promise<void>;
  className?: string;
  size?: IndicatorSizeType;
}
export const AiIndicator: FC<Props> = ({
  aiGenerated,
  regenerate,
  className,
  size = 'md',
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const onRegenerateClick = useCallback(() => {
    if (regenerate != null) {
      setIsLoading(true);
      regenerate?.().finally(() => setIsLoading(false));
    }
  }, [regenerate]);

  return (
    <>
      {isLoading ? (
        <Indicator size={size} className={className}>
          <Loading size="small" />
        </Indicator>
      ) : aiGenerated ? (
        <Indicator size={size} className={className}>
          <FormattedMessage id="ai" />
        </Indicator>
      ) : (
        <ActionableButton
          onClick={onRegenerateClick}
          className={className}
          size={size}
        >
          <FontAwesomeIcon icon={faArrowTurnLeft} />
        </ActionableButton>
      )}
    </>
  );
};
